
import { Component, Mixins } from "vue-property-decorator";
import { AbstractCheckableItem, IClickHandleable, } from "../../../../../domain/document/items";
import { IHisInformationGroupSource } from "../../../../../domain/his/groupInput/HisInformationGroupSource";
import { default as StyledCheckDrawableObjectMixin } from "./StyledCheckDrawableObjectMixin.vue";
import FreeInputableMixin from "./FreeInputableMixin.vue";
import HisInformationSelectableMixin from "./HisInformationSelectableMixin.vue";

@Component
export default class StyledCheckEditableObjectMixin extends Mixins(
  StyledCheckDrawableObjectMixin,
  FreeInputableMixin,
  HisInformationSelectableMixin,
) implements IClickHandleable {
  editingSource: AbstractCheckableItem;

  clicked() {
    if (this.isFreeInputable) {
      if (this.shouldInputFreeSelfOrAll || !this.editingSource.isHisInfo || !this.editingSource.hasText || this.editingSource.isNoDialogHisItem) {
        this.isChecked = !this.isChecked;
      } else {
        this.selectHisInformation(r => this.onHisItemSelected(r));
      }
    }
    this.emitFocus();
  }
  
  async onHisItemSelected(result: IHisInformationGroupSource): Promise<boolean> {
    if (!result) {
      this.shouldInputFree = true;
    }
    return true;  // 処理継続可否は任せる.
  }
}
